import { Button, Flex } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import SelectedFloatingFooter from 'components/Table/SelectedFloatingFooter';

interface ICostCodesTableFooter {
  selectedFlatRows: any[];
  toggleAllRowSelected: (value?: boolean) => void;
  handleBulkMapping: (value: any[]) => void;
  handleBulkUnmapping: (value: any[]) => void;
  mappedTasks: any;
  isBulkMapLoading: boolean;
  isBulkUnmapLoading: boolean;
}

const CostCodesTableFooter: React.FC<ICostCodesTableFooter> = ({
  selectedFlatRows,
  toggleAllRowSelected,
  handleBulkMapping,
  handleBulkUnmapping,
  mappedTasks,
  isBulkMapLoading,
  isBulkUnmapLoading,
}) => {
  const { t } = useTranslation(['integrations']);

  let showbulkUnmapButton = false;
  let showBulkMapButton = false;

  selectedFlatRows.forEach(row => {
    if (row.original.adp_cost_code || row.original.adp_department) {
      showbulkUnmapButton = true;
    }

    if (mappedTasks && Object.keys(mappedTasks).includes(String(row.original.id))) {
      showBulkMapButton = true;
    }
  });

  return (
    <div>
      <SelectedFloatingFooter selectedFlatRows={selectedFlatRows} toggleAllRowSelected={toggleAllRowSelected}>
        <Flex justifyContent="flex-end" sx={{ gap: '8px' }}>
          {showBulkMapButton ? (
            <Button
              mr="2"
              isLoading={isBulkMapLoading}
              variant="primary-ghost"
              onClick={() => handleBulkMapping(selectedFlatRows)}
            >
              {t('integrations:adp.bulkMap')}
            </Button>
          ) : null}
          {showbulkUnmapButton ? (
            <Button
              isLoading={isBulkUnmapLoading}
              variant="secondary-ghost"
              onClick={() => handleBulkUnmapping(selectedFlatRows)}
            >
              {t('integrations:adp.bulkUnMap')}
            </Button>
          ) : null}
        </Flex>
      </SelectedFloatingFooter>
    </div>
  );
};

export default CostCodesTableFooter;
